<template>
    <div class="icon-chat" @click="routeIcon()"
    :style="{
        background: `${colors.secondary}`,
        color: colors.theme == 'dark' ? `#fff` : `#fff`,
    }"
    >    
        <div class="notification" v-if="this.name == 'chat' && newMessages > 0">
            <p>{{newMessages}}</p>
        </div>
        <!-- <img class="img-chat" :src="img" alt=""> -->
        <Chat class="img-chat" v-if="this.name == 'chat'" />
        <div class="final-equation" v-else>
            <span>{{$t("Shared.IconHeader.finalEquation")}}</span>
        </div>
    </div>
</template>
<script>
import Chat from "../Shared/CustomIcons/Header/Chat.vue"
export default {
    components:{
        Chat
    },
    data(){
        return{
            img : require(`../../assets/${this.name}-button.png`),
            colors:{}
        }
    },
    props: {
        name:{
            type: String,
            required : true
        },
        routeName:{
            type: String,
            required : true
        },
        newMessages:{

        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    methods:{
        routeIcon(){
            this.$router.push(this.routeName)
        }
    }
}
</script>
<style lang="scss" scoped>
    .icon-chat{

            margin-left: 3px;
            position: relative;
            width: 65px;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding: 10px;
            border-radius: 12px;
            border: 1px solid #fff;
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;

        .notification{

            width: 25px;
            height: 25px;
            border-radius: 50%;
            position: absolute;
            top: -15%;
            left: -10%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 13px;
            font-weight: bold;
        }

        

        .img-chat{
            width: 32px;
        }
    }

    @media only screen and (min-width: 374px) {
        .icon-chat{

            // .img-chat{
            //     width: 55px;
            // }
        }
    }
</style>
